module.exports = __webpack_public_path__ + "static/media/1023056.c368abf8.png";